import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-cream pt-8 pb-16 md:pt-12 md:pb-24" data-id="element-83">
      <div className="max-w-prose mx-auto px-5" data-id="element-84">
        {/* Eyebrow */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-sans text-xs md:text-sm tracking-[0.2em] uppercase text-gold mb-8 md:mb-10" data-id="element-85">
          Guía práctica · Sin lácteos · Medidas USA
        </motion.p>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.25
      }} className="font-sans font-bold text-3xl md:text-5xl lg:text-[3.4rem] leading-[1.15] text-charcoal mb-5" data-id="element-86">
          No es grasa.{' '}
          <span className="text-terracotta" data-id="element-87">Es «panza globo».</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.45
      }} className="font-sans text-lg md:text-xl text-charcoal/70 mb-10 md:mb-14 leading-relaxed" data-id="element-88">
          Si tu comida saludable te infla… esto te va a enojar (y aliviar).
        </motion.p>

        {/* Decorative divider */}
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="w-16 h-[2px] bg-gold/50 mb-10 md:mb-14 origin-left" data-id="element-89" />

        {/* Opening Lead */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.9,
        delay: 0.7
      }} className="font-serif text-lg md:text-xl leading-[1.85] text-charcoal/90 space-y-6" data-id="element-90">
          <p data-id="element-91">
            Te levantas y ya lo sientes. No es "me veo un poco inflamada"… es
            esa <strong className="text-charcoal" data-id="element-92">panza tensa</strong>, ese
            botón que molesta, esa ropa que ayer "todavía pasaba" y hoy te pone
            de mal humor antes de que el día empiece.
          </p>

          <p data-id="element-93">
            Y lo peor no es la hinchazón. Lo peor es la duda:{' '}
            <strong className="text-charcoal" data-id="element-94">«¿Qué hice ahora?»</strong>
          </p>

          <p data-id="element-95">
            Porque estás intentando portarte bien. Estás comiendo "saludable".
            Estás moviéndote. Estás tomando agua. Y aun así… terminas el día
            como globo.
          </p>

          <p data-id="element-96">
            Si te suena, quiero decirte algo que tal vez nadie te dijo de forma
            clara:
          </p>

          <p className="text-xl md:text-2xl font-semibold text-terracotta leading-snug py-2" data-id="element-97">
            No estás fallando. Estás reaccionando a disparadores invisibles.
          </p>

          <p className="text-charcoal/70" data-id="element-98">
            Y sin un mapa, tu mente lo convierte en culpa.
          </p>

          {/* CTA Button */}
          <div className="pt-4" data-id="element-99">
            <a href="https://tiendadigitaljj.com//cart/43446651256910:1" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 bg-terracotta hover:bg-terracotta-dark text-white font-sans font-semibold text-base md:text-lg py-3.5 px-7 rounded-xl transition-colors duration-200 shadow-md shadow-terracotta/25" data-id="element-100">
              Quiero mi plan de 14 días
              <svg className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-101">
                <path d="M5 12h14" data-id="element-102" />
                <path d="m12 5 7 7-7 7" data-id="element-103" />
              </svg>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}